const initialstate = {
  fetching: null,
  fetchingSuccessful: null,
  fetchingFailed: null,
  error: null,
  errorText: null,
  contestReport: null,
};

const getContestReportReducer = (state = initialstate, action) => {
  switch (action.type) {
    case 'FETCHING_CONTEST_REPORT':
      return Object.assign({}, state, {
        fetching: true,
      });
    case 'FETCHING_CONTEST_REPORT_DONE':
      return Object.assign({}, state, {
        fetching: false,
        fetchingSuccessful: true,
        fetchingFailed: false,
        error: false,
        errorText: '',
        contestReport: action.payload,
      });
    case 'FETCHING_CONTEST_REPORT_FAILED':
      return Object.assign({}, state, {
        fetching: false,
        fetchingFailed: true,
        error: true,
        errorText: action.payload,
        contestReport: null,
      });
    default:
      return state;
  }
};

export default getContestReportReducer;
